import { Box, Card, styled, Typography } from "@mui/material";

export const BigCarouselCardStyled = styled(Card)(({ theme }) => ({
  cursor: "pointer",
  height: "25rem",
  borderRadius: "16px",
  overflow: "hidden",
  position: "relative",
  border: `2px solid ${theme.customColors.border}`,
  boxSizing: "border-box",
  backgroundColor: `rgba(${theme.customColors.gradient08End})`, // sync color between card background and the end of the gradient
  backgroundPosition: "right center",
  backgroundRepeat: "no-repeat",
  transition: "all 0.35s ease",
  [theme.breakpoints.down("md")]: {
    height: "24rem"
  },
  [theme.breakpoints.down("sm")]: {
    height: "18rem"
  },
  "&::after": {
    content: "\"\"",
    position: "absolute",
    top: 0,
    right: 0,
    width: "60%",
    height: "100%",
    background: `
       linear-gradient(
    to left,
    rgba(0, 0, 0, 0),
    rgba(${theme.customColors.gradient08End})
    )`,
    pointerEvents: "none",
    zIndex: 1
  },
  "&::before": {
    content: "\"\"",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "16px",
    pointerEvents: "none",
    //boxShadow: `0 0 8px 2px ${theme.customColors.border} inset`,
    opacity: 0,
    transition: "opacity 0.7s ease",
    zIndex: 2
  },
  "&:hover": {
    border: `2px solid ${theme.customColors.borderAccent}`
  }
}));

export const TypeContainer = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingTop: theme.spacing(2)
}));

export const StyledType = styled(Typography)(() => ({
  fontWeight: "bold",
  fontSize: "0.9rem"
}));

export const ContainerTitleSubTitle = styled(Box)(() => ({
  flexWrap: "wrap",         // allow text wrapping
  width: "100%",
  zIndex: 2
}));

export const StyledTitle = styled(Typography)<{ $isRTL?: boolean }>(({ theme, $isRTL }) => ({
  maxWidth: "100%",
  color: theme.customColors.exploreCardText,
  direction: $isRTL ? "rtl" : "ltr",
  overflow: "visible",
  whiteSpace: "normal",
  wordBreak: "break-word",
  textShadow: `0 0 4px ${theme.customColors.gradient08Start}`,
  fontSize: "1.5rem",
  fontWeight: "700",
  lineHeight: "2rem",
  textAlign: $isRTL ? "right" : "left"
}));

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "0.875rem",
  fontWeight: "500",
  lineHeight: "1.5rem",
  marginTop: theme.spacing(2),
  maxWidth: "90%",
  opacity: 0.8,
  overflowWrap: "break-word",
  whiteSpace: "normal",
  wordBreak: "break-word"
}));

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "90%"
}));

export const StyledBoxTopLeft = styled(Box)(
  () => ({
    position: "absolute",
    zIndex: 4,
    top: "1.5rem",
    left: "1.5rem",
    bottom: "1.5rem",
    width: "38%"
  })
);

export const StyledBoxTopRight = styled(Box)(
  () => ({
    position: "absolute",
    display: "flex",
    zIndex: 4,
    justifyContent: "flex-end",
    flexWrap: "wrap",
    right: "1.5rem",
    top: "1.5rem",
    gap: "0.5rem"

  })
);
